<template>
  <div
    class="text-white flex flex-col !justify-between !bg-cover !bg-no-repeat lg:!w-[340px] md:!w-[340px] w-[300px] h-[230px] p-1 rounded-xl mb-2"
    :style="{backgroundImage}"
  >
    <div class="flex flex-col items-end gap-[5px]">
      <div class="flex gap-1">
        <div
          class="rounded-full px-[10px] py-[3px]"
          :class="['badge', badge]"
        >
          {{ data.level === 'gold' ? 'Gold' : data.level === 'bronze' ? 'Bronze' : 'Platinum' }}
        </div>
        <img
          src="https://storage.googleapis.com/komerce/assets/elements/Mastercard-logo.svg"
          alt="mastercard"
          width="30"
        >
      </div>
    </div>
    <div class="flex flex-col items-end gap-1">
      <div class="flex items-center gap-3">
        <div
          v-if="data.labels"
          class="flex items-center gap-2"
        >
          <div class="cursor-pointer">
            <img
              v-b-popover.hover.top="data.labels"
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/note-text.svg"
              alt="note"
              width="17"
            >
          </div>
          <div class="w-[1px] h-[15px] bg-white" />
        </div>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="6"
            cy="6"
            r="6"
            :fill="renderColorStatus(data.status)"
          />
        </svg>
        {{ renderStatus(data.status) }}
      </div>
      <div class="capitalize font-medium text-xl">
        {{ data.name }}
      </div>
      <span class="font-normal text-[#C2C2C2]">xxxx xxxx xxxx xxxx {{ data.card_number }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    theme() {
      const disabledStatuses = new Set(['freeze', 'cancel', 'inactive'])
      const { status = '', level = '' } = this.data || {}

      // URLs centralized so it's easy to change later
      const urls = {
        disabled: 'https://storage.googleapis.com/komerce/Komcards/disable-card.svg',
        gold: 'https://storage.googleapis.com/komerce/assets/media/Komcards-Cards-gold.svg',
        platinum: 'https://storage.googleapis.com/komerce/assets/svg/platinum.svg',
        bronze: 'https://storage.googleapis.com/komerce/assets/elements/Cards-bronze.svg',
      }

      // If disabled status -> always use disabled theme
      if (disabledStatuses.has(status)) {
        return {
          backgroundImage: `url(${urls.disabled})`,
          badge: 'bg-[#626262]',
          actionClass: 'cursor-not-allowed bg-[#414242]',
        }
      }

      // Level mapping for non-disabled states
      const levelMap = {
        gold: {
          backgroundImage: `url(${urls.gold})`,
          badge: 'bg-[#F6B732]',
          actionClass: 'bg-[#BC9744] cursor-pointer',
        },
        platinum: {
          backgroundImage: `url(${urls.platinum})`,
          badge: 'bg-[#414242]',
          actionClass: 'bg-[#626262] cursor-pointer',
        },
        default: {
          backgroundImage: `url(${urls.bronze})`,
          badge: 'bg-[#686868]',
          actionClass: 'bg-[#686868] cursor-pointer',
        },
      }

      return levelMap[level] || levelMap.default
    },
    backgroundImage() {
      return this.theme.backgroundImage
    },
    badge() {
      return this.theme.badge
    },
  },
  methods: {
    renderStatus(status) {
      if (status === 'active') {
        return 'Aktif'
      }
      if (status === 'inactive') {
        return 'Tidak Aktif'
      }
      if (status === 'freeze') {
        return 'Dibekukan'
      }
      if (status === 'cancel') {
        return 'Cancelled'
      }
      return 'Pending'
    },
    renderColorStatus(status) {
      if (status === 'active') {
        return '#34A770'
      }
      if (status === 'inactive') {
        return '#E31A1A'
      }
      if (status === 'freeze') {
        return '#828282'
      }
      if (status === 'cancel') {
        return '#828282'
      }
      return '#828282'
    },

  },
}
</script>

<style scoped>
